import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 overflow-hidden border border-white/15 bg-[#0a1633]">
                <img src="/operexa-logo.jpg" alt="Operexa Gennex" className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="font-display font-bold text-white text-base">Operexa Gennex</div>
                <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">Private Limited</div>
              </div>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-sm">
              Enterprise-grade outsourcing, automation, and digital solutions
              built for fast-growing global businesses.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="text-zinc-300 hover:text-white">Services</Link></li>
              <li><Link to="/industries" className="text-zinc-300 hover:text-white">Industries</Link></li>
              <li><Link to="/projects" className="text-zinc-300 hover:text-white">Projects</Link></li>
              <li><Link to="/about" className="text-zinc-300 hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-zinc-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#3B82F6] shrink-0" />
                <a href="mailto:communications@operexagennex.com" className="hover:text-white break-all">communications@operexagennex.com</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#3B82F6] shrink-0" />
                <span>+91 94778 56303</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#3B82F6] shrink-0" />
                <span>Space Nex - 361, Kalitala Road, North Pubachal, Kolkata - 700078</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Operexa Gennex Private Limited. All rights reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-zinc-600 uppercase">Engineered for Performance · Governed for Scale</p>
        </div>
      </div>
    </footer>
  );
}
